/* ============================================================
   quick-view.js — Quick View popup (snippets/quick-view-modal.liquid).

   Ported from the static build's home-extra.js "Quick view" section,
   with one real improvement: the static build's size buttons were
   always the same cosmetic "XS S M L XL" set, never tied to a real
   variant (its own code comment admitted this — "abhi kisi size ke
   paas real per-variant photo nahi hai"). This version fetches the
   real product via /products/{handle}.js and renders real size pills
   tied to real variant ids, so Add to Bag here adds the variant the
   shopper actually selected.
   ============================================================ */
(function () {
  "use strict";

  var qv = document.querySelector("[data-qv]");
  if (!qv) return;

  var qvImg = qv.querySelector("[data-qv-img]");
  var qvMain = qv.querySelector(".qv__main");
  var qvPrev = qv.querySelector("[data-qv-prev]");
  var qvNext = qv.querySelector("[data-qv-next]");
  var qvThumbs = qv.querySelector("[data-qv-thumbs]");
  var qvTitle = qv.querySelector("[data-qv-title]");
  var qvPrice = qv.querySelector("[data-qv-price]");
  var qvLink = qv.querySelector("[data-qv-link]");
  var qvAdd = qv.querySelector("[data-qv-add]");
  var qvSizes = qv.querySelector("[data-qv-sizes]");
  var qvImages = [];
  var qvIndex = 0;
  var selectedVariantId = null;

  function fmt(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.GHONCHE_MONEY_FORMAT);
    }
    return "Rs. " + Math.round((Number(cents) || 0) / 100).toLocaleString("en-PK");
  }

  function setQvImage(i) {
    if (!qvImages.length) return;
    qvIndex = (i + qvImages.length) % qvImages.length;
    qvImg.src = qvImages[qvIndex];
    qvThumbs.querySelectorAll(".qv__thumb").forEach(function (t, idx) {
      t.classList.toggle("is-on", idx === qvIndex);
      t.setAttribute("aria-selected", idx === qvIndex ? "true" : "false");
    });
  }

  function renderGallery(images, alt) {
    qvImages = images.length ? images : [""];
    qvThumbs.innerHTML = "";
    var multi = qvImages.length > 1;
    qvPrev.hidden = !multi;
    qvNext.hidden = !multi;
    if (multi) {
      qvImages.forEach(function (src, idx) {
        var thumb = document.createElement("button");
        thumb.type = "button";
        thumb.className = "qv__thumb";
        thumb.setAttribute("role", "tab");
        thumb.setAttribute("aria-label", "Image " + (idx + 1) + " of " + qvImages.length);
        thumb.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
        thumb.addEventListener("click", function () { setQvImage(idx); });
        qvThumbs.appendChild(thumb);
      });
    }
    qvImg.alt = alt || "";
    setQvImage(0);
  }

  function renderSizes(product) {
    qvSizes.innerHTML = "";
    selectedVariantId = null;
    if (product.variants.length <= 1 && product.variants[0].title === "Default Title") {
      selectedVariantId = product.variants[0].id;
      qvAdd.disabled = !product.variants[0].available;
      return;
    }
    product.variants.forEach(function (v) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = v.title;
      if (!v.available) btn.disabled = true;
      btn.addEventListener("click", function () {
        qvSizes.querySelectorAll("button").forEach(function (b) { b.classList.remove("is-on"); });
        btn.classList.add("is-on");
        selectedVariantId = v.id;
        qvPrice.textContent = fmt(v.price);
        qvAdd.disabled = !v.available;
      });
      qvSizes.appendChild(btn);
    });
    var firstAvailable = product.variants.filter(function (v) { return v.available; })[0];
    if (firstAvailable) {
      var idx = product.variants.indexOf(firstAvailable);
      qvSizes.children[idx].classList.add("is-on");
      selectedVariantId = firstAvailable.id;
    }
  }

  function openQV(handle) {
    fetch("/products/" + handle + ".js").then(function (r) { return r.json(); }).then(function (product) {
      renderGallery(product.images.slice(), product.title);
      qvTitle.textContent = product.title;
      qvPrice.textContent = fmt(product.price);
      if (qvLink) qvLink.href = "/products/" + product.handle;
      renderSizes(product);
      qv.hidden = false;
      if (window.__ghoncheLockPageScroll) window.__ghoncheLockPageScroll(true);
    });
  }

  function closeQV() {
    qv.hidden = true;
    if (window.__ghoncheLockPageScroll) window.__ghoncheLockPageScroll(false);
  }

  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-quick-view]");
    if (t) {
      e.preventDefault();
      var card = t.closest(".card");
      var qa = card ? card.querySelector("[data-quick-add]") : null;
      if (qa && qa.dataset.handle) openQV(qa.dataset.handle);
      return;
    }
    if (e.target.closest("[data-qv-close]") || e.target === qv) { closeQV(); return; }
    if (e.target.closest("[data-qv-add]")) {
      if (selectedVariantId && window.GhoncheCart) {
        window.GhoncheCart.addToCart(selectedVariantId, 1).then(function () {
          closeQV();
          window.GhoncheCart.openDrawer();
        });
      }
      return;
    }
    if (e.target.closest("[data-qv-prev]")) { setQvImage(qvIndex - 1); return; }
    if (e.target.closest("[data-qv-next]")) { setQvImage(qvIndex + 1); return; }
  });

  var qvTouchX = null;
  if (qvMain) {
    qvMain.addEventListener("touchstart", function (e) { qvTouchX = e.touches[0].clientX; }, { passive: true });
    qvMain.addEventListener("touchend", function (e) {
      if (qvTouchX === null) return;
      var dx = e.changedTouches[0].clientX - qvTouchX;
      qvTouchX = null;
      if (Math.abs(dx) > 40) setQvImage(qvIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeQV(); return; }
    if (qv.hidden) return;
    if (e.key === "ArrowLeft") setQvImage(qvIndex - 1);
    if (e.key === "ArrowRight") setQvImage(qvIndex + 1);
  });
})();
